export default __webpack_public_path__ + "static/media/clock.87dd294f.svg";